import ApiError from "./ApiError";
import {IAnyObject} from "../../common/SimpleInterface";

export default class ApiResponseVO
{
    apiError: ApiError | null = null;
    data:IAnyObject = {};
    message:string = "";
    failedToLoad: boolean = false;
    hasNoInternetConnection: boolean = false;
    invalidLogin: boolean = false;
    invalidCredentials: boolean = false;
    response:any|null = null;
    endpoint:string|null = null;
}